import { useState, useEffect, useRef } from 'react'
import styles from './BadgeToERSPropertyMappingManager.module.css'
import { useNavigate, useLocation, Link } from 'react-router-dom'

// ------ Services ------ //
import * as clientEventService from '../../../services/clientEventService'

const BadgeToERSPropertyMappingManager = () => {
    const navigate = useNavigate()
	const location = useLocation()
    const passedState = location.state
    // useLocation & useNavigate --- Client state from previous page
    const [clientEventInfo, setClientEventInfo] = useState({})
    const clientEventInfoRef = useRef(null);
    if (clientEventInfoRef === null || clientEventInfoRef.current === null) {
        if (!passedState || !passedState.clientName) {
            clientEventInfoRef.current = clientEventService.getClientEvent();
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            clientEventInfoRef.current =passedData
        }
       
    }
    useEffect(() => {
        // reflects client/event selection changes made in Header.jsx without polling
        const handleClientEventChange = (e) => {
            // Update clientevent with every render when its value has changed.
            let savedClientEvent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current && clientEventInfoRef.current.eventId !== undefined &&
                savedClientEvent && savedClientEvent.eventId !== undefined &&
                savedClientEvent.eventId !== clientEventInfoRef.current.eventId) {
                setClientEventInfo(savedClientEvent)
                clientEventInfoRef.current = savedClientEvent;
            }
        }
        window.addEventListener('clientEventChange', handleClientEventChange)
        return () => window.removeEventListener('clientEventChange', handleClientEventChange)
    }, [])

    useEffect(() => {
        // store into local object
        if (!passedState || !passedState.clientName) {
            //let localclientevent = clientEventService.getClientEvent()
            if (clientEventInfoRef.current) {
                setClientEventInfo(clientEventInfoRef.current)
            }
        }
        else {
            let passedData = {
                clientName: passedState.clientName,
                clientId: passedState.clientId,
                eventName: passedState.eventName,
                eventId: passedState.eventId,
            }
            setClientEventInfo(passedData)
            clientEventInfoRef.current = passedData;
        }

    }, [])
	return (
        <div id={styles.eventConfigurePage}>
            <h1>Badge to ERS Property Mapping Management</h1><br />
            <h2>Controls badge template field mapping to ERS properties - Main or Guest.</h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/BadgeToERSPropertyMapping`} state={clientEventInfo} className={styles.eventLinks} title="Main badge property mapping.">
                    <h3>Main Badge Mapping</h3>
                </Link>
                <Link to={`/BadgeToERSPropertyGuestMapping`} state={clientEventInfo} className={styles.eventLinks} title="Guest badge property mapping.">
                    <h3>Guest Badge Mapping</h3>
                </Link>
                <Link to={`/RegistrantToGuestMapping`} state={clientEventInfo} className={styles.eventLinks} title="Control mapping between registrant and guest objects.">
                    <h3>Registrant to Guest Mapping</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default BadgeToERSPropertyMappingManager;